import { createSelector } from 'reselect';

const authorisationSelector = (state) => state.get('authorisation');

const messagesSelector = createSelector(
    authorisationSelector, (authorisation) => authorisation.get('message')
);

const fieldsSelector = createSelector(
    authorisationSelector, (authorisation) => authorisation.get('fields')
);

const errorSelector = createSelector(
    authorisationSelector, (authorisation) => authorisation.get('error')
);

const loggedInUserSelector = createSelector(
    authorisationSelector, (authorisation) => authorisation.get('loggedInUser')
);

export default state => {

    return {
        loggedInUser: loggedInUserSelector(state),
        userMessage: messagesSelector(state),
        userFields: fieldsSelector(state),
        userError: errorSelector(state),
    };
};
